<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.deletionExecution") }}
      </h5>

      <div
        v-if="execution.scope && execution.scope.is_notable"
        class="alert alert-danger mb-3"
      >
        {{ execution.scope.label }}
      </div>

      <CdrSubExaminationImpactDisclosure
        v-if="execution.sub_examination_impact"
        :impact="execution.sub_examination_impact"
      />

      <CdrIntegrationAcknowledgements
        :transfers="execution.integration_transfers || []"
        @change="integrationAcks = $event"
      />

      <div class="form-check mb-3">
        <input
          id="delete-acknowledge"
          v-model="acknowledged"
          class="form-check-input"
          type="checkbox"
        />
        <label class="form-check-label" for="delete-acknowledge">
          {{ trans("admin.cdr.deletionAcknowledge") }}
        </label>
      </div>

      <button
        type="button"
        class="btn btn-danger"
        :disabled="!canSubmit || submitting"
        @click="submit"
      >
        {{ trans("admin.cdr.executeDeletion") }}
      </button>
    </div>
  </div>
</template>

<script>
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";
import CdrIntegrationAcknowledgements from "./CdrIntegrationAcknowledgements.vue";
import CdrSubExaminationImpactDisclosure from "./CdrSubExaminationImpactDisclosure.vue";
import { integrationAcksComplete } from "./cdr-integration-acks";

export default {
  components: {
    CdrIntegrationAcknowledgements,
    CdrSubExaminationImpactDisclosure,
  },
  props: {
    flag: { type: Object, required: true },
    execution: { type: Object, required: true },
    apiUrl: { type: String, required: true },
  },
  emits: ["updated"],
  data() {
    return {
      acknowledged: false,
      submitting: false,
      integrationAcks: [],
    };
  },
  computed: {
    canSubmit() {
      return this.acknowledged && integrationAcksComplete(this.integrationAcks);
    },
  },
  methods: {
    submit() {
      this.submitting = true;
      practitionerHttpService
        .post(this.apiUrl + this.flag.id + "/execute-delete", {
          acknowledge: true,
          integration_acknowledgements: this.integrationAcks,
        })
        .then((res) => {
          this.submitting = false;
          this.$emit("updated", res.data);
        })
        .catch((error) => {
          this.submitting = false;
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
